import React from "react";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Config from "conFig.js";
import { Error, Success } from "../../../../assets/jss/util/messageUtil";
import { isLessThanDay } from "../../../../assets/jss/util/validateUtil";

const Themhopdonglaodong = React.memo(function Themhopdonglaodong(props) {
  const { laixe_id } = props;
  const [sohdld, setSohdld] = React.useState("");
  const [loaihdld, setLoaihdld] = React.useState([]);
  const [loaihdld_id, setLoaihdld_id] = React.useState(0);
  const [trangthaihdld, setTrangthaihdld] = React.useState([]);
  const [trangthaihdld_id, setTrangthaihdld_id] = React.useState(0);
  const [ngay_batdau, setNgay_batdau] = React.useState(dayjs());
  const [ngay_ketthuc, setNgay_ketthuc] = React.useState(dayjs());
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  //const [disableBT, setDisableBT] = React.useState(true);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getloaihopdong = () => {
    var url = Config.backend + "/api/Donvi/getdmloaihdld?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setLoaihdld(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const gettrangthai = () => {
    var url =
      Config.backend + "/api/Donvi/getdmtrangthaihdld?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTrangthaihdld(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const themhopdong = () => {
    let mess = validateThem();
    if (mess === Success.SC0001) {
      var batdau =
        ngay_batdau.$y +
        "-" +
        String(ngay_batdau.$M + 1).padStart(2, "0") +
        "-" +
        ngay_batdau.$D;
      var ketthuc =
        ngay_ketthuc.$y +
        "-" +
        String(ngay_ketthuc.$M + 1).padStart(2, "0") +
        "-" +
        ngay_ketthuc.$D;
      var url = Config.backend + "/api/Donvi/themlaixehdld";
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          laixe_id: laixe_id,
          sohdld: sohdld,
          ngay_batdau: batdau,
          ngay_ketthuc: ketthuc,
          loaihdld_id: loaihdld_id,
          trangthaihdld_id: trangthaihdld_id,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            showNotification();
          } else showNotification1();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const validateThem = () => {
    // Kiem tra ngay bat dau HĐLĐ va ngay ke thuc HĐLĐ
    if (isLessThanDay(ngay_ketthuc, ngay_batdau)) {
      return Error.ER0052;
    }
    // Kiem tra cac truong bat buoc nhap
    if (sohdld.trim() === "") {
      return Error.ER0053;
    }
    if (!loaihdld_id || loaihdld_id === 0) {
      return Error.ER0054;
    }
    if (!trangthaihdld_id || trangthaihdld_id === 0) {
      return Error.ER0055;
    }
    return Success.SC0001;
  };
  React.useEffect(() => {
    getloaihopdong();
    gettrangthai();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Số hợp đồng lao động"
                variant="outlined"
                size="small"
                value={sohdld}
                onChange={(event) => {
                  setSohdld(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày bắt đầu"
                  value={ngay_batdau}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgay_batdau(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày két thúc"
                  value={ngay_ketthuc}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgay_ketthuc(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                options={loaihdld}
                getOptionLabel={(option) => option.ten}
                onChange={(event, value) => {
                  setLoaihdld_id(value.id);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setLoaihdld_id(null);
                  } else {
                    setLoaihdld_id(
                      loaihdld.find(({ ten }) => ten === newInputValue).id
                    );
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Loại hợp đồng lao động"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                options={trangthaihdld}
                getOptionLabel={(option) => option.ten}
                onChange={(event, value) => {
                  setTrangthaihdld_id(value.id);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setTrangthaihdld_id(null);
                  } else {
                    setTrangthaihdld_id(
                      trangthaihdld.find(({ ten }) => ten === newInputValue).id
                    );
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Trạng thái HĐ"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "20px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          //disabled={disableBT}
          onClick={themhopdong}
        >
          Thêm
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Thêm thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình thêm"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

Themhopdonglaodong.propTypes = {
  laixe_id: PropTypes.number,
};
export default Themhopdonglaodong;
